import { formatCount } from '../runtime/format.js';
import { cx } from '../utils/cx.js';

/**
 * 件数バッジ（tab-label 11/16 はここと タブバーのラベルにだけ許された例外）。
 * tone: neutral = 黒の塗り（自分宛て）、warning = 未送信件数（別の意味の数字）
 */
export function CountBadge({ count, tone = 'neutral', className, label }: { count: number; tone?: 'neutral' | 'warning'; className?: string; label?: string }) {
  if (count <= 0) return null;
  return (
    <span
      className={cx('inline-flex min-h-4 min-w-4 items-center justify-center rounded-pill px-1.5 text-tab-label tabular', tone === 'warning' ? 'bg-warning text-state-on' : 'bg-brand text-brand-on', className)}
      aria-label={label ? `${label} ${count} 件` : undefined}
    >
      {formatCount(count)}
    </span>
  );
}

/** 未読ドット（数えないもの） */
export function Dot({ className }: { className?: string }) {
  return <span className={cx('inline-block h-2 w-2 rounded-pill bg-fg', className)} aria-hidden="true" />;
}
